export default {
  features: {
    warehouseItemToggleAlifshopOfferVisibility: {
      show: 'Выставить на продажу',
    },
  },
};
